import { Device, DeviceDAO } from "@app2u/notifications";

export class LocalStorageDeviceDAO implements DeviceDAO {
  DEVICE_ID_DB_KEY = "deviceId";
  notSentDevice(): Device | null {
    const deviceId = window.localStorage.getItem(this.DEVICE_ID_DB_KEY);
    return deviceId != null ? { identifier: deviceId } : null;
  }
  create(deviceId: string): void {
    window.localStorage.setItem(this.DEVICE_ID_DB_KEY, deviceId);
  }
  update(deviceId: string, isSent: boolean): void {
    if (isSent) {
      return;
    }
    window.localStorage.setItem(this.DEVICE_ID_DB_KEY, deviceId);
  }
  exists(deviceId: string): boolean {
    const storedDeviceId = window.localStorage.getItem(this.DEVICE_ID_DB_KEY);
    return storedDeviceId === deviceId;
  }
}
